module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sample_render"
  }, [_c('div', {
    staticClass: "sample_text"
  }, [_c('v-icon', [_vm._v("link")]), _vm._v("샘플 페이지")], 1), _vm._v(" "), _c('div', {
    staticClass: "items_wrapper"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": _vm.ipUrl,
      "title": _vm.ipmsg,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("PC 풀스크린")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": _vm.pcIpSkinUrl,
      "title": _vm.ipSkinPc,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("PC 브랜드플러스")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": _vm.ipPerformancePc,
      "title": _vm.ipPerformancePcmsg,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("PC 퍼포먼스")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": _vm.ipShortsPc,
      "title": _vm.ipShortsPcmsg,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("PC 숏츠")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": _vm.ipSavePc,
      "title": _vm.ipShortsPcmsg,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("PC Save")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box2"
  }, [_c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": _vm.mipmsg
    },
    on: {
      "click": function($event) {
        return _vm.test($event)
      }
    }
  }, [_c('span', [_vm._v("MO 풀스크린")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": _vm.nhbamsg
    },
    on: {
      "click": function($event) {
        return _vm.moBrandUpCheck($event)
      }
    }
  }, [_c('span', [_vm._v("MO 브랜드플러스")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": _vm.ipPerformanceMomsg
    },
    on: {
      "click": function($event) {
        return _vm.ohipPerformanceMo($event)
      }
    }
  }, [_c('span', [_vm._v("MO 퍼포먼스")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": _vm.ipShortsMomsg
    },
    on: {
      "click": function($event) {
        return _vm.ohipShortsMo($event)
      }
    }
  }, [_c('span', [_vm._v("MO 숏츠")])])]), _vm._v(" "), _c('div', {
    staticClass: "link_txt"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": _vm.ipSaveMomsg
    },
    on: {
      "click": function($event) {
        return _vm.ohipSaveMo($event)
      }
    }
  }, [_c('span', [_vm._v("MO Save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-064a9e78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainScreen/SamplePage.vue
// module id = 828
// module chunks = 1